import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { GeographicArea } from '../../../_models/user/geographicArea';
import { GeographicAreasService } from './geographic-areas.service';

@Injectable({
  providedIn: 'root'
})
export class GeographicAreasResolver  {
  constructor(private geographicAreasService: GeographicAreasService) {
  }

  resolve(route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): Observable<GeographicArea[]> {
    return this.geographicAreasService.getEnabledGeographicAreas();
  }
}
